import UserRowComponent from './UserRowComponent';

export default UserRowComponent;
